import { defineComponent as _defineComponent } from 'vue'
import { BKModal } from '@/shared/ui/modals'
import { ref } from 'vue'
import SearchEvents from '@/pages/EventsPage/ui/SearchEvents.vue'
import { mdiMagnify } from '@mdi/js'
import { EventPeriod } from '@/enitites/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchEventsDialog',
  emits: ["changed-tab"],
  setup(__props, { emit }: { emit: ({ (e: 'changed-tab', tab: EventPeriod): void }), expose: any, slots: any, attrs: any }) {

const isShow = ref(false)


return { __sfc: true,isShow, emit, BKModal, SearchEvents, mdiMagnify }
}

})